module.exports = __webpack_public_path__ + "static/img/iron 1.0fd4ee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/iron 1.png
// module id = Mvgf
// module chunks = 35